import Vue from 'vue'

import analytics from './helpers/analytics'
import assets_helper from './helpers/assets_helper'
import campaign_card from './components/organisms/campaign_card/index.vue'
import checkbox_group from './components/organisms/checkbox_group/index.vue'
import click_tracker from './directives/click_tracker'
import content_discovery_card from './components/organisms/content_discovery_card/index.vue'
import digital_asset_edit_modal from './components/organisms/digital_asset_edit_modal/index.vue'
import digital_asset_folder from './components/molecules/digital_asset_folder.vue'
import digital_asset_gallery from './components/organisms/digital_asset_gallery/index.vue'
import digital_asset_uploader from './components/organisms/digital_asset_uploader/index.vue'
import digital_asset_view_modal from './components/organisms/digital_asset_view_modal/index.vue'
import email_share_preview from './components/organisms/email_share_preview/index.vue'
import embed_file from './components/organisms/embed_file/index.vue'
import empty_content_panel from './components/organisms/empty_content_panel/index.vue'
import facebook_embed_file from './components/molecules/facebook_embed_file/index.vue'
import facebook_share_preview from './components/organisms/facebook_share_preview/index.vue'
import folder_modal from './components/organisms/folder_modal/index.vue'
import instagram_share_preview from './components/organisms/instagram_share_preview/index.vue'
import landing_page_grid from './components/molecules/landing_page_grid/index.vue'
import media_card from './components/molecules/media_card.vue'
import media_image from './components/molecules/media_image.vue'
import external_video_card from './components/molecules/external_video_card.vue'
import pbxx_filter_pills from './components/filter_pills/index.vue'
import pbxx_color_picker from './components/molecules/pbxx_color_picker/index.vue'
import rich_text_editor from './components/organisms/rich_text_editor/index.vue'
import selector from './components/molecules/selector.vue'
import twitter_share_preview from './components/organisms/twitter_share_preview/index.vue'
import vimeo_embed_file from './components/molecules/vimeo_embed_file/index.vue'
import youtube_embed_file from './components/molecules/youtube_embed_file/index.vue'
import froala_text_editor from './components/molecules/froala.vue'

import '@promoboxx/pbxxfont'
import '@promoboxx/pbxxfont/dist/promoboxx-icon-regular.css'
import './styles/index_with_pbxxfont.scss'
import truncate_filter from './filters/truncate'
import VueCloudinary from 'vue-cloudinary'

require('froala-editor/js/froala_editor.pkgd.min')
require('froala-editor/css/froala_editor.pkgd.min.css')
require('font-awesome/css/font-awesome.css')
require('froala-editor/css/froala_style.min.css')

import VeeValidate from 'vee-validate'
const config = {
  errorBagName: 'errors',
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: {
    en: {
      custom: {
        external_video_url: {
          url: 'External video url is not valid'
        }
      }
    }
  },
  strict: false,
  classes: true,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'is-success', // model is valid
    invalid: 'is-error', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: false, // do not automatically inject $validator into components, recommended to disable when using SSR (Nuxt)
  validity: false,
  aria: true
}

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import Froala from 'vue-froala-wysiwyg'

Vue.config.productionTip = false

export default {
  install: (Vue, options) => {
    const { cloudinary_configuration_options } = options
    Vue.component('assets_helper', assets_helper)
    Vue.component('campaign_card', campaign_card)
    Vue.component('checkbox_group', checkbox_group)
    Vue.component('content_discovery_card', content_discovery_card)
    Vue.component('digital_asset_edit_modal', digital_asset_edit_modal)
    Vue.component('digital_asset_folder', digital_asset_folder)
    Vue.component('digital_asset_gallery', digital_asset_gallery)
    Vue.component('digital_asset_uploader', digital_asset_uploader)
    Vue.component('digital_asset_view_modal', digital_asset_view_modal)
    Vue.component('email_share_preview', email_share_preview)
    Vue.component('embed_file', embed_file)
    Vue.component('empty_content_panel', empty_content_panel)
    Vue.component('facebook_embed_file', facebook_embed_file)
    Vue.component('facebook_share_preview', facebook_share_preview)
    Vue.component('folder_modal', folder_modal)
    Vue.component('instagram_share_preview', instagram_share_preview)
    Vue.component('landing_page_grid', landing_page_grid)
    Vue.component('media_card', media_card)
    Vue.component('media_image', media_image)
    Vue.component('pbxx_filter_pills', pbxx_filter_pills)
    Vue.component('pbxx_color_picker', pbxx_color_picker)
    Vue.component('rich_text_editor', rich_text_editor)
    Vue.component('selector', selector)
    Vue.component('twitter_share_preview', twitter_share_preview)
    Vue.component('vimeo_embed_file', vimeo_embed_file)
    Vue.component('youtube_embed_file', youtube_embed_file)
    Vue.component('external_video_card', external_video_card)
    Vue.component('froala_editor', { name: 'froala_editor', components: { froala_text_editor } })

    Vue.filter('truncate', truncate_filter)

    Vue.directive('click_tracker', click_tracker)

    Vue.use(VeeValidate, config)
    Vue.use(Froala)
    Vue.use(ElementUI, { locale })
    Vue.use(VueCloudinary, cloudinary_configuration_options)
  },
  assets_helper,
  analytics,
}
